"use client";
import { Button } from "@/components/ui/button";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import { BlockUpdateFunction } from ".";
import { SettingTabs } from "../../content/SettingTabs";
import AdminPopover from "../../content/AdminPopover";
import SpotifyOptions from "./tabs/spotify/options";
import BlockToggle from "./tabs/toggle";
import BlockMetadata from "./tabs/metadata";
import { Separator } from "@/components/ui/separator";

interface Props {
    admin?: boolean;
    user: IUserData;
    block: IBlocks;
    update: BlockUpdateFunction;
    newBlock?: string | null;
}
export default function BlockSpotify({
    admin,
    user,
    block,
    update,
    newBlock,
}: Props) {
    const [isExpanded, setIsExpanded] = React.useState(false);
    React.useEffect(() => {
        if (newBlock === block.id) {
            handleExpand();
        }
        return () => {
            window.removeEventListener("closeBlock", handleClose);
        };
    }, [newBlock, block.id]);
    React.useEffect(() => {
        window.addEventListener("closeBlock", {
            handleEvent: (event: CustomEvent) => {
                if (event.detail.id != block.id) {
                    if (isExpanded) {
                        setIsExpanded(false);
                    }
                }
            },
        });
    });
    React.useEffect(() => {
        if (block != blockUpdate) {
            setBlockUpdate(block);
        }
    }, [block]);
    const handleClose = () => {
        setIsExpanded(false);
        window.dispatchEvent(new CustomEvent("collapseBlock"));
    };
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    //@ts-ignore
    let type = blockUpdate.url.split("/")[block.url.split("/").length - 2];
    //@ts-ignore
    // blockUpdate.url =
    //     blockUpdate.url.split("/")[block.url.split("/").length - 1];
    const url = blockUpdate.url.split("/")[block.url.split("/").length - 1];
    function handleUpdate(value: IBlocks) {
        if (value == null) {
            update(blockUpdate.id, value, true);
            return;
        }
        setBlockUpdate({
            ...blockUpdate,
            ...value,
        });
        if (block == value) return;
        update(blockUpdate.id, value);
    }
    const event = new CustomEvent("expandBlock", {
        detail: {
            id: blockUpdate.id,
            title: "Spotify",
            titleOptions: (
                <BlockToggle
                    block={blockUpdate}
                    blockUpdate={setBlockUpdate}
                    update={handleUpdate}
                />
            ),
            content: (
                <div className="flex flex-col gap-3 pb-3">
                    <SpotifyOptions
                        block={blockUpdate}
                        blockUpdate={setBlockUpdate}
                        update={handleUpdate}
                    />
                    <BlockMetadata block={blockUpdate} update={handleUpdate} />
                </div>
            ),
        },
    });
    const handleExpand = () => {
        window.dispatchEvent(
            new CustomEvent("closeBlock", {
                detail: {
                    id: block.id,
                },
            })
        );
        setIsExpanded(true);
        window.dispatchEvent(event);
    };
    React.useEffect(() => {
        if (isExpanded) {
            window.dispatchEvent(event);
        }
    }, [blockUpdate]);
    return (
        <AdminPopover
            admin={admin}
            className={block.show ? "" : "opacity-30"}
            title={`Spotify - ${blockUpdate.url}`}
            onClick={handleExpand}
            isOpen={isExpanded}
            onClose={handleClose}
        >
            <iframe
                id="spotify"
                style={{ borderRadius: "12px" }}
                src={`https://open.spotify.com/embed/${type}/${url}?utm_source=generator&theme=0`}
                width="100%"
                height="152"
                frameBorder="0"
                allowFullScreen={false}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
            />
        </AdminPopover>
    );
}
